"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SyringeIcon = props => _react.default.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.2267 4.95754L16.1667 0.997536L14.9733 2.52246L16.6827 3.86025L15.1934 5.62187L11.9859 3.11693L10.7941 4.64307L16.4997 9.09896L14.4054 11.7811L13.4427 11.0668L12.5773 12.2332L13.5114 12.9262L12.3654 14.3938L11.1796 13.492L10.3004 14.648L11.4716 15.5386L9.68585 17.8256L6.99714 17.6231L6.15155 15.0583L11.8029 7.82615L10.2771 6.63386L4.30708 14.2739C4.10797 14.5287 4.04922 14.8661 4.15047 15.1732L5.19828 18.3512L2.99753 21.1633L4.52245 22.3567L6.72343 19.5443L10.0573 19.7955C10.3802 19.8198 10.6938 19.6811 10.8931 19.4259L18.0258 10.2908L18.4641 10.6331L19.6559 9.10693L16.7207 6.81463L18.2087 5.05452L20.0333 6.48246L21.2267 4.95754Z",
  fill: "currentColor"
}));

var _default = SyringeIcon;
exports.default = _default;